import React from 'react';

interface HowItWorksProps {
  onNavigate: (path: string) => void;
}

const HowItWorks: React.FC<HowItWorksProps> = ({ onNavigate }) => {
  return (
    <section id="how-it-works" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold inline-block mb-4">
            💡 Simpel & Effectief
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Hoe werkt het?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            In 3 eenvoudige stappen voorbereid op je WFT examen
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {/* Step 1 */}
          <div className="relative">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 h-full border-2 border-blue-200 hover:shadow-xl transition-shadow">
              {/* Step Number Badge */}
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                1
              </div>
              
              {/* Icon */}
              <div className="text-6xl mb-6 mt-4">📝</div>
              
              {/* Content */}
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Kies je examen
              </h3>
              <p className="text-gray-600 mb-4">
                Selecteer uit WFT Schade Particulier, Basis, Hypotheken of een ander examen. Elke module is speciaal afgestemd op de exameneisen.
              </p>
              
              {/* Feature Pills */}
              <div className="flex flex-wrap gap-2">
                <span className="bg-white px-3 py-1 rounded-full text-xs font-medium text-blue-700">
                  9 examens
                </span>
                <span className="bg-white px-3 py-1 rounded-full text-xs font-medium text-blue-700">
                  Actueel
                </span>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="relative">
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-8 h-full border-2 border-purple-200 hover:shadow-xl transition-shadow">
              {/* Step Number Badge */}
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                2
              </div>
              
              {/* Icon */}
              <div className="text-6xl mb-6 mt-4">🤖</div>
              
              {/* Content */}
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Oefen met AI
              </h3>
              <p className="text-gray-600 mb-4">
                Onze AI genereert unieke vragen op basis van je zwakke punten. Train specifieke onderwerpen of maak complete proefexamens.
              </p>
              
              {/* Feature Pills */}
              <div className="flex flex-wrap gap-2">
                <span className="bg-white px-3 py-1 rounded-full text-xs font-medium text-purple-700">
                  Gevalideerde wft vragen
                </span>
                <span className="bg-white px-3 py-1 rounded-full text-xs font-medium text-purple-700">
                  Slimme hints
                </span>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="relative">
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 h-full border-2 border-green-200 hover:shadow-xl transition-shadow">
              {/* Step Number Badge */}
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-br from-green-600 to-emerald-600 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                3
              </div>
              
              {/* Icon */}
              <div className="text-6xl mb-6 mt-4">🎯</div>
              
              {/* Content */}
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Haal je examen
              </h3>
              <p className="text-gray-600 mb-4">
                Volg je voortgang, verbeter je zwakke punten en haal uiteindelijk je examen in één keer. 
              </p>
              
              {/* Feature Pills */}
              <div className="flex flex-wrap gap-2">
                <span className="bg-white px-3 py-1 rounded-full text-xs font-medium text-green-700">
                  Officiele toetstermen
                </span>
                <span className="bg-white px-3 py-1 rounded-full text-xs font-medium text-green-700">
                  Live stats
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Below Steps */}
        <div className="text-center mt-16">
          <button 
            onClick={() => onNavigate('/register')}
            className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-10 py-4 rounded-lg text-lg font-semibold hover:shadow-2xl transform hover:scale-105 transition inline-flex items-center space-x-2"
          >
            <span>Probeer het nu gratis</span>
            <span>→</span>
          </button>
          <p className="text-gray-500 text-sm mt-4">
            Geen creditcard nodig • Gratis uitproberen
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;